import { addImageLinks } from "./ProductModel"


 const hideFollowingIds = {
  "008000000": true, // Beard Head
  "012000000": true,// , Gamago
  "011000000": true,// , Hikali
  "010000000": true,// , Hoobbe
  "026000000": true,// , Nanoku
  "015000000": true,// , Seishin
  "009000000": true,// , Slam
  "027000000": true,// , The Source
  "020000000": true,// , Tobar
  "025000000": true,// Treat Factory
  "035000000": true,// Chasing Threads
  "018000000": true,// NPW
  "028000000": true// iThinking
}


export default class CategoryModel {
  constructor( data ) {
    this.validate( data )
    addImageLinks( data )
    Object.assign( this, data )

    this.cssClass = "cat-" + data.map_id
    this.title = this.desc.short_des

    if ( hideFollowingIds[ data.map_id ] ) {
      this.hide = true
    }

    if ( this.title === "All Around" ) {
      this.title = "All around the world"
    }

    this.description = this.desc.des
  }

  validate() {
    if ( !this.desc || !this.desc.des ) {
      this.desc = this.desc || {}
      this.desc.des = "NOT SET"
      this.desc.short_des = "NOT SET"
    }
    return true
  }
}




// WEBPACK FOOTER //
// ./src/sdk/CategoryModel.js